import { useEffect } from "react";
import { getTimezoneCode } from "../../helpers/getTimezoneCode";

const useTimezone = () => {

  useEffect(() => {
    localStorage.setItem("timezone", getTimezoneCode());
  }, []);
};

export default useTimezone;
